import styled, { css } from "styled-components";
import { colorsPalettes, setFontVariant, rgba } from "@similarweb/styles";
import { SWReactTableWrapperBox } from "app/components/React/Table/SWReactTableGhostLoader";
import { SWReactTableWrapperFooter } from "app/components/React/Table/SWReactTableWrapper";
import { TrendContainer } from "app/components/React/Table/cells/TrendCell";
import { LeftFlexRow, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { Button, IconButton, SearchInput, Tab, TabList } from "@similarweb/ui-components";
import { SWReactIcons } from "@similarweb/icons";
import { EXPANDED_WIDGET_HEIGHT } from "app/pages/digital-marketing/keywords-campaigns/reports/pages-report/table/PagesReportTableConsts";

interface IDisableable {
    isDisabled?: boolean;
}

export const Title = styled.div`
    ${setFontVariant("h5", colorsPalettes.carbon[500])};
`;

export const OrganicLandingPagesTableHeaderStyled = styled(FlexRow)`
    justify-content: space-between;
    height: 63px;
    align-items: center;
    padding: 0 24px;
`;

export const FiltersWrapper = styled(FlexRow)`
    background: ${colorsPalettes.bluegrey[100]};
    padding-bottom: 24px;
    flex-wrap: wrap;
    gap: 8px;
`;

const BooleanSearchFilterWrapper = styled.div`
    width: max-content;
    margin-right: 8px;
`;
interface IOrganicLandingPagesV2Wrapper {
    activeRowClickHeight?: string;
}
export const OrganicLandingPagesV2Wrapper = styled.div<IOrganicLandingPagesV2Wrapper>`
    ${SWReactTableWrapperBox} {
        box-shadow: none;
    }
    ${SWReactTableWrapperFooter} {
        box-shadow: 0 3px 6px 0 ${rgba(colorsPalettes.midnight[600], 0.08)};
    }
    .organic-landing-pages-2-table {
        box-shadow: 3px 0 6px 0 ${rgba(colorsPalettes.midnight[600], 0.08)};
    }
    .DropdownContent-container-enrich {
        z-index: 1070 !important;
        margin-top: 56px !important;
    }
    .active-row-clicked {
        height: ${(props) => props.activeRowClickHeight ?? `${EXPANDED_WIDGET_HEIGHT}px`};
    }
`;

export const OverviewWrapper = styled.div`
    background: ${colorsPalettes.carbon[0]};
    border-radius: 6px 6px 0 0;
    box-shadow: 0 3px 6px 0 ${rgba(colorsPalettes.midnight[600], 0.08)};
`;

export const TableTopWrapper = styled.div`
    background: ${colorsPalettes.bluegrey[100]};
`;

const FilterItemWrapper = styled.div`
    margin-left: 8px;
`;

export const StyledEnrichButtonText = styled.div<IDisableable>`
    ${({ isDisabled = false }) => setFontVariant("drilldown", colorsPalettes.carbon[isDisabled ? 100 : 400])}
`;

export const StyledEnrichButtonNumber = styled.div<IDisableable>`
    ${({ isDisabled = false }) => setFontVariant("input2", colorsPalettes.carbon[isDisabled ? 100 : 400])}
`;

export const StyledEnrichButton = styled(IconButton)<IDisableable>`
    background: ${colorsPalettes.carbon[0]};
    padding: 0 4px;
    border-radius: 4px;
    border: 1px solid ${colorsPalettes.carbon[50]};
    ${SWReactIcons} {
        margin-right: 2px;
    }
    > .SWReactIcons > svg > path {
        fill: ${(props) => colorsPalettes.carbon[props.isDisabled ? 100 : 400]};
    }

    ${(props) =>
        !props.isDisabled &&
        css`
            &:hover {
                border: 1px solid ${colorsPalettes.carbon[100]};
                border-radius: 4px;
                background: ${colorsPalettes.blue[200]};
                ${StyledEnrichButtonText} {
                    color: ${colorsPalettes.blue[400]};
                }
                ${StyledEnrichButtonNumber} {
                    color: ${colorsPalettes.blue[400]};
                }
                > .SWReactIcons > svg > path {
                    fill: ${colorsPalettes.blue[400]};
                }
            }
        `}
`;

export const TableWrapper = styled.div`
    .active-row {
        ${StyledEnrichButton}:not(.enrich--disabled) {
            background: ${colorsPalettes.blue[200]};
            border: 1px solid ${colorsPalettes.carbon[100]};
            border-radius: 4px;
            ${StyledEnrichButtonText} {
                color: ${colorsPalettes.blue[400]};
            }
            ${StyledEnrichButtonNumber} {
                color: ${colorsPalettes.blue[400]};
            }
            > .SWReactIcons > svg > path {
                fill: ${colorsPalettes.blue[400]};
            }
        }
    }
`;

export const TrafficShareContainer = styled.div`
    width: 170px;
    margin-left: 20px;
    .swTable-progressBar {
        margin-top: -3px;
        margin-bottom: 5px;
    }
`;

export const HeaderTitle = styled.div`
    margin-bottom: 8px;
`;

const SearchInputStyled = styled(SearchInput as any)`
    margin-bottom: 0;
    min-width: 220px;

    .SearchInput {
        margin-bottom: 0;
    }
`;

// enriched component styles

export const ButtonStyled = styled(Button)`
    margin-right: 16px;
`;

export const TopContainer = styled(FlexRow)`
    padding: 16px 20px 16px 19px;
    align-items: center;
    justify-content: space-between;
    border-bottom: solid 1px ${colorsPalettes.carbon[100]};
    margin-bottom: 7px;
`;

export const DataContainer = styled(LeftFlexRow)`
    flex-grow: 1;
`;

export const PageContainer = styled.div`
    width: 300px;
    border: none;
`;

export const TabStyled = styled(Tab)`
    ${SWReactIcons} {
        margin-right: 8px;
    }
    &.selected svg path {
        fill: ${colorsPalettes.blue[400]};
    }
`;

export const CloseIconButton = styled(IconButton)`
    margin-left: 8px;
`;

export const IndexContainer = styled.div`
    margin-left: 8px;
`;
